import { useCallback } from 'react'
import {hotjar} from 'react-hotjar'

export const useHotjar = () => {

    const initializeHotjar = useCallback(() => {
        if(process.env.REACT_APP_HOTJAR_ID && process.env.REACT_APP_HOTJAR_TRACK_ID){
            hotjar.initialize(Number(process.env.REACT_APP_HOTJAR_ID), Number(process.env.REACT_APP_HOTJAR_TRACK_ID))
        }
    }, [])

    const trackHotjar = useCallback((actionName:string, productType:string) => {
        if(!hotjar.initialized()) {
            return;
        }
        if(productType === 'mtpl'){
            if(window.location.href.indexOf("-smart-drive") > -1 ){
                productType = "emtpl-smart-drive"
            } else {
                productType = "emtpl"
            }
        }
        const eventName = `store/${productType}${actionName ? "/" : ""}${actionName}`
        console.log("Hotjar stateChange:", eventName)
        hotjar.stateChange(eventName)
    }, [])

    return ({
        initializeHotjar,
        trackHotjar
    })
}